import { render } from "./table.vue?vue&type=template&id=7d05dada&scoped=true"
const script = {}

import "./table.vue?vue&type=style&index=0&id=7d05dada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d05dada"]])

export default __exports__